import React, {useMemo} from "react";
import {formatISO} from "date-fns";

import {useApartmentPricesQuery} from "../query";
import {useRates} from "../RateContext";


const QueryMonthDataLoader = ({Month, dateStart, dateEnd, ...props}) => {
    const {accUnitSelector} = useRates();
    const selectedApartment = accUnitSelector.selectedAccommodationUnit;

    const dateFromISO = dateStart && formatISO(dateStart, {representation: "date"});
    const dateToISO = dateEnd && formatISO(dateEnd, {representation: "date"});

    const apartmentId = selectedApartment?.id;

    const gridDataQuery = useApartmentPricesQuery({ apartmentId, dateFromISO, dateToISO });

    const formattedData = useMemo(() => {
            if (gridDataQuery.data?.length > 0) {
                return organizeRatePrices(gridDataQuery.data);
            }
            return null;
        },
        [gridDataQuery.data]);

    return <Month {...props} gridData={formattedData} isLoading={gridDataQuery.isLoading || gridDataQuery.isFetching}/>
};

/*
 * Organize the rates from the api and convert them to the format expected by the planner.
 */
const organizeRatePrices = (data) => {
    const base = data.filter(rate => rate.isBase)[0];  // TODO return the data for all the rates

    // Create an object with key the date ISO (timestamp) and value the data for that date.
    return base.timestamps.reduce( (acc, timestamp, i) => {
        acc[timestamp] = {
            pricesCent: base.prices
                .reduce((acc, p) => {
                acc[p.people] = p.pricesCent[i];
                return acc;
            }, {}),
            checkin: base.checkin[i],
            checkout: base.checkout[i],
            minNights: base.minNights[i],
            minPeople: base.minPeople[i],
            enabled: base.enabled[i],
        }
        return acc;
    }, {});
}

export default QueryMonthDataLoader;